import {AfterViewInit, Component, Inject, QueryList, ViewChild} from '@angular/core';
import {DialogResult, DialogResultType} from '../DialogResult';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {InteractPoDPage} from '../../api/models/interact-po-dpage';
import {Observable} from 'rxjs/internal/Observable';
import {MatList, MatListOption, MatSelectionList, MatSelectionListChange} from '@angular/material/list';
import {PodLayoutEx} from '../../api/models/pod-layout-ex';
import {US_Bookmark} from '../../api/models/us_bookmark';
import {US_SubHeader} from '../../api/models/us_sub-header';
import {ShareState} from '../../elements/share-editor/share-editor.component';
import {DodLayoutEx} from '../../api/models/dod-layout-ex';
import {FilterKeys} from '../../api/models/filter-keys';
import {DodEndPointEx} from '../../api/models/dod-end-point-ex';
import {ScrollStrategyOptions} from '@angular/cdk/overlay';
import {TextSearchValue} from '../../elements/filter-editor/text-search-filter/text-search-filter.component';
import {Company} from '../../api/models/company';
import {CompanyKey} from '../../api/models/company-key';
import {JobDepartment} from '../../api/models/job-department';
import {JobSeniority} from '../../api/models/job-seniority';
import {TitleKey} from '../../api/models/title-key';
import {JobSenioritySearchComponent} from '../../elements/filter-editor/job-seniority-search.component';
import {FullTitleSearchComponent} from '../../elements/filter-editor/full-title-search/full-title-search.component';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {AzureConfig} from '../../api/models/azure-config';
import {AwsConfig} from '../../api/models/aws-config';
import {SftpConfig} from '../../api/models/sftp-config';
import {EmailConfig} from '../../api/models/email-config';


export enum DataOnDemandDestinationType {
  Email = 0,
  Sftp = 1,
  AzureBlob = 2,
  AWS = 3
}

export class DodLayoutDialogData {
  dodLayout: DodLayoutEx;
  dodEndPoint: DodEndPointEx;
  shareState: ShareState;
  isOwner: boolean;
}

export class DataOnDemandLayoutDialogResult {
  dodLayout: DodLayoutEx;
  shareState: ShareState;
}

@Component({
  selector: 'data-on-demand-layout-dialog',
  templateUrl: './data-on-demand-layout-dialog.component.html',
  styleUrls: ['./data-on-demand-layout-dialog.component.css'],
})
export class DataOnDemandLayoutDialogComponent implements AfterViewInit {

  @ViewChild(FullTitleSearchComponent, {static: false}) titleSearchComponent: FullTitleSearchComponent;

  public result: DataOnDemandLayoutDialogResult;
  public selectedSubscriptionId: number = -1;
  public shareState: ShareState;
  public isOwner: boolean;
  public filterKeys: FilterKeys;
  public dodEndPoint: DodEndPointEx;
  public additionalData: AdditionalData[] = [];

  public destinationId : DataOnDemandDestinationType = DataOnDemandDestinationType.Email;

  public azureConfig: AzureConfig = {
    connectionString: "",
    containerName: "",
    path: ""
  };

  public awsConfig: AwsConfig = {
    accessKey: "",
    secretKey: "",
    region: "",
    bucketName: "",
    path: ""
  };

  public sftpConfig: SftpConfig = {
    host: "",
    port: 0,
    userName: "",
    password: "",
    path: ""
  };

  public emailConfig: EmailConfig = {
    emailAddress: ""
  };

  public companySelectedValues: TextSearchValue<Company> = {
    searchTerms: [],
    selectedValues: []
  }

  public titleValues: TitleKey[] = [];

  constructor(
    public dialogRef: MatDialogRef<DataOnDemandLayoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DodLayoutDialogData
  ) {

    this.result = {
      dodLayout: JSON.parse(JSON.stringify(data.dodLayout)),
      shareState: data.shareState
    }

    this.dodEndPoint = data.dodEndPoint;

    this.additionalData = this.dodEndPoint.subData.map<AdditionalData>(x => {
      return {
        key: x.key,
        title: x.title,
        selected: false
      }
    });

    this.selectedSubscriptionId = this.data.dodEndPoint.subHeaders[0].subscriptionId;
    this.shareState = data.shareState;
    this.isOwner = data.isOwner;
    if (data.dodLayout.filterData) {
      this.filterKeys = JSON.parse(data.dodLayout.filterData);
    } else {
      this.filterKeys = {
        titles: [],
        occupations: [],
        regions: [],
        companies: [],
        industries: [],
        dateRangeType: 0,
        dateRange: 0
      }
    }

    //this.titleValues = this.filterKeys.titles;

    this.companySelectedValues = {
      searchTerms: this.filterKeys.companies.filter(x => x.search).map(x => x.search),
      selectedValues: this.filterKeys.companies.filter(x => x.key).map<Company>(x => {
        return {
          key: x.key,
          name: x.displayName
        }
      })
    };

    const selectedAdditionalDataKeys = data.dodLayout.subDataSelected?.split(',');

    this.additionalData.forEach(x => {
      x.selected = selectedAdditionalDataKeys?.indexOf(x.key) >= 0;
    });

    this.destinationId = data.dodLayout.destinationId;

    if (this.destinationId === DataOnDemandDestinationType.Email) {
      this.emailConfig.emailAddress = data.dodLayout.emailConfig?.emailAddress ?? "";
    } else if (this.destinationId === DataOnDemandDestinationType.Sftp) {
      this.sftpConfig.host = data.dodLayout.sftpConfig?.host ?? "";
      this.sftpConfig.port = data.dodLayout.sftpConfig?.port ?? 0;
      this.sftpConfig.userName = data.dodLayout.sftpConfig?.userName ?? "";
      this.sftpConfig.password = data.dodLayout.sftpConfig?.password ?? "";
      this.sftpConfig.path = data.dodLayout.sftpConfig?.path ?? "";
    } else if (this.destinationId === DataOnDemandDestinationType.AzureBlob) {
      this.azureConfig.connectionString = data.dodLayout.azureConfig?.connectionString ?? "";
      this.azureConfig.containerName = data.dodLayout.azureConfig?.containerName ?? "";
    } else if (this.destinationId === DataOnDemandDestinationType.AWS) {
      this.awsConfig.accessKey = data.dodLayout.awsConfig?.accessKey ?? "";
      this.awsConfig.secretKey = data.dodLayout.awsConfig?.secretKey ?? "";
      this.awsConfig.region = data.dodLayout.awsConfig?.region ?? "";
      this.awsConfig.bucketName = data.dodLayout.awsConfig?.bucketName ?? "";
      this.awsConfig.path = data.dodLayout.awsConfig?.path ?? "";
    }

    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.titleValues = this.filterKeys.titles;
      this.titleSearchComponent.forceRefresh();
    })
  }

  hasCompanies() : boolean {
    return this.dodEndPoint && this.dodEndPoint.filters && this.dodEndPoint.filters.some(x => x.key === 'Company');
  }

  hasTitles() : boolean {
    return this.dodEndPoint && this.dodEndPoint.filters && this.dodEndPoint.filters.some(x => x.key === 'Title');
  }

  hasIndustries() : boolean {
    return this.dodEndPoint && this.dodEndPoint.filters && this.dodEndPoint.filters.some(x => x.key === 'Industry');
  }

  hasOccupations() : boolean {
    return this.dodEndPoint && this.dodEndPoint.filters && this.dodEndPoint.filters.some(x => x.key === 'Occupation');
  }

  hasRegions() : boolean {
    return this.dodEndPoint && this.dodEndPoint.filters && this.dodEndPoint.filters.some(x => x.key === 'Region');
  }

  onTabChange($event: MatTabChangeEvent) {
    if ($event.tab.textLabel === 'Titles') {
      this.titleSearchComponent.forceRefresh();
    }
  }

  public Result: DialogResult;

  static showDialog(
    dialog: MatDialog,
    dodEndPoint: DodEndPointEx,
    dodLayout: DodLayoutEx,
    shareState: ShareState,
    isOwner: boolean
  ): Observable<DialogResult> {
    const params: DodLayoutDialogData = {
      dodEndPoint,
      dodLayout,
      shareState,
      isOwner
    };

    const dialogRef = dialog.open(DataOnDemandLayoutDialogComponent, {
      disableClose: true,
      width: '900px',
      data: params,

    });

    return dialogRef.afterClosed();
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onSaveLayout(): void {
    this.closeDialog();
  }

  closeDialog(): void {
    this.result.dodLayout.subscriptionId = this.selectedSubscriptionId;

    this.filterKeys.companies = [];
    this.filterKeys.companies =
      [
        ...this.companySelectedValues.searchTerms.map<CompanyKey>(x => {return {search: x}}),
        ...this.companySelectedValues.selectedValues.map<CompanyKey>(x => {return {key: x.key, displayName: x.name}})
      ];
    this.filterKeys.titles = this.titleValues;

    this.result.dodLayout.filterData = JSON.stringify(this.filterKeys);
    this.result.dodLayout.subDataSelected = this.additionalData.filter(x => x.selected).map(x => x.key).join(',');

    this.result.shareState = this.shareState;

    this.result.dodLayout.destinationId = this.destinationId;

    if (this.destinationId === DataOnDemandDestinationType.Email) {
      this.result.dodLayout.emailConfig = this.emailConfig;
    } else if (this.destinationId === DataOnDemandDestinationType.Sftp) {
      this.result.dodLayout.sftpConfig = this.sftpConfig;
    } else if (this.destinationId === DataOnDemandDestinationType.AzureBlob) {
      this.result.dodLayout.azureConfig = this.azureConfig;
    } else if (this.destinationId === DataOnDemandDestinationType.AWS) {
      this.result.dodLayout.awsConfig = this.awsConfig;
    }

    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }
}

export class AdditionalData
{
  public key: string;
  public title: string;
  public selected: boolean;
}
